<template>
  <div class="country-opening text-gray-600 lg:flex lg:justify-center">
    <div class="country-opening-container">
      <div class="lg:flex lg:flex-row-reverse lg:items-end">
        <div class="usps-container bg-gray-50 lg:rounded-r-md">
          <div class="flex items-center pb-rem lg:pb-rem">
            <i18n tag="p" class="ota-h2 pr-3" :path="`TryItNow.${i18nKey}.Title`">
              <template #emoji>
                <OSvg :svg="country" class="inline" />
              </template>
            </i18n>
          </div>
          <USPs :usps="usps" />
          <div class="text-center pt-5 lg:pt-7">
            <OButton
              variant="secondary"
              @click="$emit('click')"
            >
              {{ isTwoForOneCampaign ? $t('TwoForOneCampaign.TryForFree') : $t(`TryItNow.${i18nKey}.TryForFree`) }}
            </OButton>
            <p class="pt-rem ota-p14 text-sm" v-text="$t(`TryItNow.${i18nKey}.TryForFreeDescription`)" />
          </div>
        </div>
        <div>
          <OImage
            v-bind="countryImage"
            img-class="country-opening-image mx-auto lg:rounded-l-md"
          />
        </div>
      </div>
      <div class="pt-5 lg:pt-rem">
        <div class="py-5 px-12 rounded-md bg-gray-50 lg:flex lg:justify-around">
          <div
            v-for="(detail, index) in details"
            :key="`${detail.Detail}-${index}`"
            class="text-center"
            :class="{
              'pb-7 lg:pb-0': index !== details.length -1
            }"
          >
            <div class="flex justify-center items-center">
              <OSvg v-if="index === 1" svg="star" class="w-5 h-5 mr-rem" />
              <p class="ota-h3" v-text="detail.Detail" />
            </div>
            <p class="ota-p14" v-text="detail.Description" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import USPs from '@/components/USPs'
import OButton from '@/components/OButton'
import OImage from '@/components/OImage'
import OSvg from '@/components/OSvg'
import { MenPrices } from '@/enums/products'
import { getImagePaths, addLocalCurrency } from '@/utils/general'
import { Currencies, CountryCodes } from '@/enums/general'

export default {
  name: 'CountryOpening',
  components: { USPs, OButton, OImage, OSvg },
  props: {
    country: {
      type: String,
      default: 'nl'
    },
    locale: {
      type: String,
      default: 'nl'
    },
    isTwoForOneCampaign: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    countryImage () {
      const country = this.country.toLowerCase()

      return getImagePaths({
        path: `/images/frontend/try-now/countries/${country}/banner-${country}`,
        s3: true
      })
    },
    i18nKey () {
      return `Opening${this.country.toUpperCase()}`
    },
    details () {
      return [...Array(this.$t(`TryItNow.${this.i18nKey}.OTADetails`).length)].map((_, index) => ({
        Detail: this.$t(`TryItNow.${this.i18nKey}.OTADetails[${index}].Detail`, {
          memberCount: this.getMemberCount(this.country),
          starsAmount: 4.5
        }),
        Description: this.$t(`TryItNow.${this.i18nKey}.OTADetails[${index}].Description`, {
          reviewCount: this.getReviewCount(this.country)
        })
      }))
    },
    usps () {
      return [...Array(this.$t(`TryItNow.${this.i18nKey}.USPS`).length)].map((_, index) => this.$t(`TryItNow.${this.i18nKey}.USPS[${index}]`, { price: this.localPrice }))
    },
    localPrice () {
      return addLocalCurrency(MenPrices[this.country], `${this.locale}-${this.country.toUpperCase()}`, Currencies[this.country])
    }
  },
  methods: {
    getMemberCount (country = 'nl') {
      if (country === CountryCodes.norway) {
        return '500 000'
      }

      return '500.000'
    },
    getReviewCount (country = 'nl') {
      if (country === CountryCodes.norway) {
        return 22469
      }

      return 22.469
    }
  }
}
</script>

<style lang="postcss" scoped>
.usps-container {
  padding: 7rem 5rem;
}

.oimage >>> .country-opening-image {
  max-width: 100% !important;
}

>>> .ota-usps {
  &-container {
    @apply p-0;

    svg {
      @apply fill-gray-600 w-4 h-4;
    }
  }
}

@screen lg {
  .country-opening-container {
    max-width: 91.4rem;
  }

  .oimage >>> img.country-opening-image {
    max-width: unset !important;
    width: 41.2rem;
  }

  .usps-container {
    max-height: 48.9rem;
    height: 48.9rem;
  }

  >>> .ota-usps {
    @apply px-0 !important;

    &-container-grid {
      @apply grid-cols-1;

      .text-sm {
        font-size: 1.6rem;
      }
    }
  }
}
</style>
